export const session = function(key, value) {
    if (value === void(0)) {
        var lsVal = sessionStorage.getItem(key);
        if (lsVal && lsVal.indexOf('yidaword-') === 0) {
            return JSON.parse(lsVal.split('yidaword-')[1]);
        } else {
            return lsVal;
        }
    } else {
        if (typeof(value) === "object" || Array.isArray(value)) {
            value = 'yidaword-' + JSON.stringify(value);
        };
        return sessionStorage.setItem(key, value);
    }
}

export const storage = function(key, value) {
    return session(key, value);
    // if (value === void(0)) {
    //     var lsVal = localStorage.getItem(key);
    //     if (lsVal && lsVal.indexOf('yidaword-') === 0) {
    //         return JSON.parse(lsVal.split('yidaword-')[1]);
    //     } else {
    //         return lsVal;
    //     }
    // } else {
    //     if (typeof(value) === "object" || Array.isArray(value)) {
    //         value = 'yidaword-' + JSON.stringify(value);
    //     };
    //     return localStorage.setItem(key, value);
    // }
}

export const deepcopy = function(source) {
    if (!source) {
        return source;
    }
    let sourceCopy = source instanceof Array ? [] : {};
    for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? deepcopy(source[item]) : source[item];
    }
    return sourceCopy;
};

export const buildMenu = function(array, ckey) {
    let menuData = [];
    let indexKeys = Array.isArray(array) ? array.map((e) => { return e.id }) : [];
    ckey = ckey || 'parentId';
    array.forEach(function(e, i) {
        if (!e[ckey] || (e[ckey] === e.id)) {
            delete e[ckey];
            menuData.push(deepcopy(e));
        } else if (Array.isArray(indexKeys)) {
            let parentIndex = indexKeys.findIndex(function(id) {
                return id == e[ckey];
            });
            if (parentIndex === -1) {
                menuData.push(e);
            }
        }
    });
    let findChildren = function(parentArr) {
        if (Array.isArray(parentArr) && parentArr.length) {
            parentArr.forEach(function(parentNode) {
                array.forEach(function(node) {
                    if (parentNode.id === node[ckey]) {
                        if (parentNode.children) {
                            parentNode.children.push(node);
                        } else {
                            parentNode.children = [node];
                        }
                    }
                });
                if (parentNode.children) {
                    findChildren(parentNode.children);
                }
            });
        }
    };
    findChildren(menuData);
    return menuData;
}

export const catchError = function(error) {
    if (error.response) {
        switch (error.response.status) {
            // case 400:
            //   Vue.prototype.$message({
            //     message: error.response.data.message || '请求参数异常',
            //     type: 'error'
            //   });
            //   break;
            case 401:
                sessionStorage.removeItem('token');
                if (error.response.config.url.indexOf('oauthep/uaa/oauth/token') == -1) {
                    location.reload();
                }
                break;
                // case 403:
                //   Vue.prototype.$message({
                //     message: error.response.data.message || '无访问权限，请联系企业管理员',
                //     type: 'warning'
                //   });
                //   break;
                // default:
                //   Vue.prototype.$message({
                //     message: error.response.data.message || '服务端异常，请联系技术支持',
                //     type: 'error'
                //   });
        }
    }
    error.response = error.response || {};
    let data = error.response.data ? error.response.data : error.response;
    return Promise.reject(data || {message: ''});
}

export const decimalTwo = (num) => { //保留两位小数
    let num_ = (num + '').replace(/[^\d.]/g, "").replace(/^\./g, "").replace(/\.{2,}/g, ".").replace(".", "$#$").replace(/\./g, "").replace("$#$", ".");
    return parseFloat(num_ || 0).toFixed(2);
}